import { APIModel } from './api-model.model'

export class APICountry extends APIModel {
    countryId: number;
    countryName: string;
    countryShort: string;
    countryCurrency: string;
    countryCurrencyExchange: number;
    countryCode: number;
    countryEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        countryId: number;
        countryName: string;
        countryShort: string;
        countryCurrency: string;
        countryCurrencyExchange: number;
        countryCode: number;
        countryEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.countryId = params.countryId
        this.countryName = params.countryName
        this.countryShort = params.countryShort
        this.countryCurrency = params.countryCurrency
        this.countryCurrencyExchange = params.countryCurrencyExchange
        this.countryCode = params.countryCode
        this.countryEnabled = params.countryEnabled ? 1 : 0
    }
}
